
import { styled } from '@core-ui/react-stitch';

const RelatedCategoriesDivision = styled.div(({isBRRedesignEnabled, theme}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  maxWidth: '1280px',
  marginRight: 'auto',
  marginLeft: 'auto',
  paddingRight: '1rem',
  paddingLeft: '1rem',
  '& .tag-link-group': {
    width: '100%',
    maxWidth: '768px',
    marginRight: 'auto',
    marginLeft: 'auto',
    '@media (min-width: 1024px)': {
      marginRight: '0',
    },
    '@media (min-width: 1280px)': {
      maxWidth: '1024px',
    },
  },
  ...isBRRedesignEnabled && {
    maxWidth: '100%',
    width: '100%',
    justifyContent: 'flex-start',
    fontSize: '1rem',
    '& .tag-link-group': {
      maxWidth: '100%',
      marginRight: '0',
      marginLeft: '0',
      '@media (min-width: 1280px)': {
        maxWidth: '100%',
      },
    },
  },
}));

  export default RelatedCategoriesDivision;
